import type { ContractDocumentData } from '../engine/types'

export const CONTRACT_DOCUMENT: ContractDocumentData = {
  title: '企业级云端文件管理平台开发及运维服务合同',
  contractNumber: 'HT-2024-CLOUD-0073',
  parties: {
    partyA: '锐峰数字科技集团有限公司（以下简称"甲方"）',
    partyB: '承接方技术团队（以下简称"乙方"）',
  },
  preamble:
    '鉴于甲方拟建设企业级云端文件管理平台，用于内部办公文件协作及对外文件分享服务，' +
    '经甲乙双方友好协商，依据《中华人民共和国合同法》及相关法律法规，' +
    '就该平台开发及运维服务事宜达成如下协议，以资共同遵守。',
  sections: [
    {
      heading: '第一条 项目范围与交付时间',
      paragraphs: [
        {
          segments: [
            { type: 'normal', text: '1.1 乙方应按照甲方需求文档，开发包含文件上传、下载、预览、目录管理等核心模块的云端文件管理平台。' },
          ],
        },
        {
          segments: [
            { type: 'normal', text: '1.2 ' },
            { type: 'keyword', text: '两周内上线文件分享功能，并支持公开传播链接', clauseId: 'CL01' },
            { type: 'normal', text: '。乙方需确保该功能按时上线并通过甲方验收。' },
          ],
        },
        {
          segments: [
            { type: 'decoy', text: '乙方应在合同签订后五个工作日内提交详细的项目排期计划', id: 'DECOY01', feedback: '这是标准的项目管理条款，合理且常见。' },
            { type: 'normal', text: '，经甲方确认后正式启动开发。' },
          ],
        },
      ],
    },
    {
      heading: '第二条 费用与结算',
      paragraphs: [
        {
          segments: [
            { type: 'normal', text: '2.1 ' },
            { type: 'keyword', text: '带宽费用不另计，流量洪峰由你方承担全部成本', clauseId: 'CL03' },
            { type: 'normal', text: '。甲方不承担任何因用户访问量激增导致的额外网络费用。' },
          ],
        },
        {
          segments: [
            { type: 'normal', text: '2.2 项目总预算包含开发费、测试费及首年运维费。' },
            { type: 'decoy', text: '付款方式按里程碑分三期支付，每期验收合格后十五个工作日内支付', id: 'DECOY02', feedback: '里程碑付款是行业标准做法，对双方都公平。' },
            { type: 'normal', text: '。' },
          ],
        },
      ],
    },
    {
      heading: '第三条 服务等级协议（SLA）',
      paragraphs: [
        {
          segments: [
            { type: 'normal', text: '3.1 ' },
            { type: 'keyword', text: '服务可用性必须达到 99.9%，任何宕机按分钟赔付', clauseId: 'CL04' },
            { type: 'normal', text: '。系统计划维护窗口需提前48小时通知甲方。' },
          ],
        },
        {
          segments: [
            { type: 'normal', text: '3.2 ' },
            { type: 'keyword', text: '第三方服务宕机也算你方违约，照常赔付', clauseId: 'CL15' },
            { type: 'normal', text: '。乙方不得以第三方服务中断作为免责理由。' },
          ],
        },
        {
          segments: [
            { type: 'normal', text: '3.3 乙方应建立7×24小时技术支持响应机制，重大故障响应时间不超过15分钟。' },
          ],
        },
      ],
    },
    {
      heading: '第四条 技术规格与限制',
      paragraphs: [
        {
          segments: [
            { type: 'normal', text: '4.1 ' },
            { type: 'keyword', text: '单文件上传上限 1TB，不得有任何大小限制', clauseId: 'CL06' },
            { type: 'normal', text: '。平台需支持大文件的断点续传及后台上传功能。' },
          ],
        },
        {
          segments: [
            { type: 'decoy', text: '乙方应确保平台兼容主流浏览器（Chrome、Firefox、Safari、Edge最新两个版本）', id: 'DECOY03', feedback: '浏览器兼容性是基本技术要求，属于常规条款。' },
            { type: 'normal', text: '，并提供移动端适配方案。' },
          ],
        },
      ],
    },
    {
      heading: '第五条 需求变更',
      paragraphs: [
        {
          segments: [
            { type: 'normal', text: '5.1 ' },
            { type: 'keyword', text: '需求变更不受限制，且不增加工期和预算', clauseId: 'CL19' },
            { type: 'normal', text: '。甲方有权在项目执行过程中随时调整功能需求，乙方应无条件配合。' },
          ],
        },
        {
          segments: [
            { type: 'decoy', text: '双方应指定专人作为项目联络人，负责日常沟通协调', id: 'DECOY04', feedback: '指定联络人是项目管理的标准做法。' },
            { type: 'normal', text: '，确保信息传递及时准确。' },
          ],
        },
      ],
    },
    {
      heading: '第六条 知识产权与保密',
      paragraphs: [
        {
          segments: [
            { type: 'normal', text: '6.1 项目开发过程中产生的所有知识产权归甲方所有。乙方不得将项目中涉及的技术方案、业务数据用于其他商业用途。' },
          ],
        },
        {
          segments: [
            { type: 'normal', text: '6.2 双方均应对合同内容及项目过程中知悉的对方商业秘密承担保密义务，保密期限为合同终止后三年。' },
          ],
        },
      ],
    },
    {
      heading: '第七条 综合条款',
      paragraphs: [
        {
          segments: [
            { type: 'normal', text: '7.1 ' },
            { type: 'keyword', text: '综上所述：两周上线，99.9% SLA，预算不变，且不得超额计费。这是最终条款', clauseId: 'CL20' },
            { type: 'normal', text: '。本合同一经签署，即对双方产生法律约束力。' },
          ],
        },
        {
          segments: [
            { type: 'normal', text: '7.2 本合同未尽事宜，由双方另行协商签订补充协议。补充协议与本合同具有同等法律效力。' },
          ],
        },
        {
          segments: [
            { type: 'normal', text: '7.3 本合同一式两份，甲乙双方各执一份，自双方签章之日起生效。' },
          ],
        },
      ],
    },
  ],
  signature: {
    partyA: '锐峰数字科技集团有限公司',
    partyB: '（乙方签章处）',
    date: '2024年12月',
  },
  decoyCount: 4,
  keywordCount: 7,
}
